<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="map-modal">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">Map</h4>
        </div>
        <div class="modal-body">
          <div id="map"></div>
        </div>
        <div class="modal-footer"></div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
</template>

<script>
import loadGoogleMaps from '@/utils/google-maps';

export default {
  name: 'google-map',

  props: [],

  methods: {
    showMap(coordinates) {
      document.querySelector('#map').innerHTML = '';
      $('#map-modal')
        .modal({ backdrop: 'static' })
        .modal('show');

      setTimeout(() => {
        if (Array.isArray(coordinates)) {
          if (coordinates.length === 1) {
            // point

            let myLatLng = {
              lat: parseFloat(coordinates[0].lat),
              lng: parseFloat(coordinates[0].lon),
            };

            let map = new google.maps.Map(document.querySelector('#map'), {
              zoom: 9,
              center: myLatLng,
              mapTypeId: 'terrain',
              mapTypeControl: true,
              zoomControl: true,
            });

            let marker = new google.maps.Marker({
              position: myLatLng,
              map: map,
              title: 'Point',
            });
          } else {
            // polygon
            let map = new google.maps.Map(document.querySelector('#map'), {
              zoom: 9,
              center: {
                lat: parseFloat(coordinates[0].lat),
                lng: parseFloat(coordinates[0].lon),
              },
              mapTypeId: 'terrain',
              mapTypeControl: true,
              zoomControl: true,
            });

            // Define the LatLng coordinates for the polygon's path.
            let shapeCoordinates = coordinates.map((c) => {
              return { lat: parseFloat(c.lat), lng: parseFloat(c.lon) };
            });

            // Construct the polygon.
            let zone = new google.maps.Polygon({
              paths: shapeCoordinates,
              strokeColor: '#FF0000',
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillColor: '#FF0000',
              fillOpacity: 0.35,
            });
            zone.setMap(map);
          }
        } else if (typeof coordinates === 'string') {
          // address

          let latlng = new google.maps.LatLng(36.151249, -86.809406);
          let mapOptions = {
            zoom: 9,
            center: latlng,
            mapTypeControl: true,
            zoomControl: true,
          };
          let map = new google.maps.Map(
            document.querySelector('#map'),
            mapOptions
          );

          let geocoder = new google.maps.Geocoder();
          geocoder.geocode({ address: coordinates }, function(results, status) {
            if (status == 'OK') {
              map.setCenter(results[0].geometry.location);
              let marker = new google.maps.Marker({
                map: map,
                position: results[0].geometry.location,
              });
            } else {
              alert(
                'Geocode was not successful for the following reason: ' + status
              );
            }
          });
        }
      }, 500);
    },
  },

  mounted() {
    loadGoogleMaps();
  },
};
</script>
